function resizeGridItem(item){
    grid = document.getElementsByClassName("masonry-grid")[0];
    rowHeight = parseInt(window.getComputedStyle(grid).getPropertyValue('grid-auto-rows'));
    rowGap = parseInt(window.getComputedStyle(grid).getPropertyValue('grid-row-gap'));
    rowSpan = Math.ceil((item.querySelector('.masonry-grid--item-body').getBoundingClientRect().height+rowGap)/(rowHeight+rowGap));
    item.style.gridRowEnd = "span "+rowSpan;
}

console.log('hi')

function resizeAllGridItems(){
    allItems = document.getElementsByClassName("masonry-grid--item");
    for(x=0;x<allItems.length;x++){
        resizeGridItem(allItems[x]);
    }
}

function resizeInstance(instance){
    item = instance.elements[0];
    resizeGridItem(item);
}

window.onload = resizeAllGridItems();
window.addEventListener("resize", resizeAllGridItems);

//console.log('foe checking code under me :)');
$(function() {
    window.dispatchEvent(new Event('resize'));
    setTimeout(function () {
        window.dispatchEvent(new Event('resize'));
    }, 1500);
    //console.log('was detected that document is ready')
});

// allItems = document.getElementsByClassName("masonry-grid--item");
// for(x=0;x<allItems.length;x++){
//     imagesLoaded( allItems[x], resizeInstance);
// }